// src/belediye/services/sahaApi.js

import api from './belediyeApi';

/**
 * Saha personeli için API servisleri.
 */
const sahaApi = {
  /**
   * FileAsset endpoint’ine tek bir dosya yükler ve yeni kaydın ID’sini döner.
   * @param {File} file
   * @returns {Promise<number>}
   */
  uploadFileAsset: async (file) => {
    const fd = new FormData();
    fd.append('file', file);
    const res = await api.post('/common/files/', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data.id;
  },

  /**
   * Birden çok dosyayı art arda yükler, ID dizisini döner.
   * @param {File[]} files
   * @returns {Promise<number[]>}
   */
  uploadFiles: async (files = []) => {
    const ids = [];
    for (const f of files) {
      const id = await sahaApi.uploadFileAsset(f);
      ids.push(id);
    }
    return ids;
  },

  /**
   * Kullanıcının atandığı tüm katılımcı kayıtlarını çeker.
   */
  fetchMyAssignments: async () => {
    try {
      const res = await api.get('/staff/participants/');
      const payload = res.data;
      if (payload && Array.isArray(payload.results)) {
        return payload.results;
      }
      if (Array.isArray(payload)) {
        return payload;
      }
      return [];
    } catch (err) {
      console.error('Saha atamaları yüklenirken hata oluştu:', err);
      const msg = err.response?.data?.detail || 'Atamaları yüklerken hata oluştu.';
      throw new Error(msg);
    }
  },

  /**
   * Tek bir katılımcı (participant) detayını getirir.
   */
  fetchParticipantById: async (participantId) => {
    if (!participantId) {
      throw new Error('Katılımcı ID’si gerekli.');
    }
    try {
      const res = await api.get(`/staff/participants/${participantId}/`);
      return res.data;
    } catch (err) {
      
      const msg = err.response?.data?.detail || 'Atama detayı alınırken hata oluştu.';
      throw new Error(msg);
    }
  },

  /**
   * Geri bildirim oluşturur:
   * 1) files array’indeki her dosyayı önce /files/ endpoint’ine upload eder,
   * 2) dönen ID’leri toplayıp JSON gövdesiyle /staff/task-feedbacks/ endpoint’ine POST eder.
   *
   * @param {{ participant: number, status: string, note: string, files?: File[] }} params
   */
  submitFeedback: async ({ participant, status, note, files = [] }) => {
    if (!participant || !status) {
      throw new Error('participant ve status alanları zorunludur.');
    }
    if (!note || !note.trim()) {
      throw new Error('Not (note) alanı boş geçilemez.');
    }

    // 1) Dosyaları upload et, ID dizisi al
    let fileIds = [];
    if (files.length) {
      fileIds = await sahaApi.uploadFiles(files);
    }

    // 2) JSON olarak geri bildirim isteği gönder
    const payload = {
      participant,
      status,
      note,
      files: fileIds,
    };

    try {
      const res = await api.post('/staff/task-feedbacks/', payload);
      return res.data;
    } catch (err) {
      
      const serverData = err.response?.data;
      const msg =
        typeof serverData === 'string'
          ? serverData
          : serverData?.detail ||
            JSON.stringify(serverData) ||
            err.message ||
            'Geri bildirim gönderilemedi.';
      throw new Error(msg);
    }
  },
};

export default sahaApi;
